import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

/**
 * A voucher scanned (ScanListener -> 'scan:voucher') while the Apply Voucher popup is NOT open: applied straight away, so the checkout
 * page needs no extra tap. While the popup is open it is the popup that takes the scan (it shows the code), so this stays out of the way.
 *   enabled:     vouchers are offered on this screen (false offline, say): the scan is left unhandled
 *   modalOpen:   the Apply Voucher popup is showing
 *   busy:        a payment is in progress, or a voucher is already being checked: the scan is refused with a message, not queued
 *   onVoucher(code): fills the code and applies it
 */
export default function useScannedVoucher({ enabled, modalOpen, busy, onVoucher }) {
  const live = useRef({});
  live.current = { enabled, busy, onVoucher };

  useEffect(() => {
    if (modalOpen) return undefined;
    const onScan = (e) => {
      const detail = e.detail || {};
      if (!detail.code || detail.handled || !live.current.enabled) return;
      detail.handled = true;
      if (live.current.busy) {
        toast.info('Wait for the payment to finish before applying a voucher');
        return;
      }
      live.current.onVoucher(detail.code);
    };
    window.addEventListener('scan:voucher', onScan);
    return () => window.removeEventListener('scan:voucher', onScan);
  }, [modalOpen]);
}
